/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useEffect, useState } from "react";
// node.js library that concatenates classes (strings)
import classnames from "classnames";
// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
import { Line, Bar, Pie } from "react-chartjs-2";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
  Media,
} from "reactstrap";

// core components
import {
  chartOptions,
  parseOptions,
  chartExample1,
  chartExample2,
} from "variables/charts.js";

import DashboardHeader from "components/Headers/DashboardHeader.js";
import { getApiDataService } from "services/apiServices";
import { DEPOSIT_REPORT, ORDER_REPORT } from "services/CONSTANTS";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import ItemReport from "./components/report/ItemReport";
import FinancialReport from "./components/report/FinancialReport";
import PaymentAccountReport from "./components/report/PaymentAccountReport";
import Expense from "./components/Expense";
import ExpenseReport from "./components/report/ExpenseReport";

const Index = (props) => {
  const [activeNav, setActiveNav] = useState(1);
  const [chartExample1Data, setChartExample1Data] = useState("data1");

  const [orderReports, setOrderReports] = useState([]);

  const [isLoadingOrderReport, setIsLoadingOrderReport] = useState(false);

  let start = moment().startOf("day").toISOString();
    let end = moment().endOf("day").toISOString();
  const [orderStartDate, setOrderStartDate] = useState(start);
  const [orderEndDate, setOrderEndDate] = useState(end);

  const [region, setRegion] = useState("Myanmar");
 

  const handleOrderCallback = (start, end, label) => {
    console.log(start.toISOString(), "startDate1");
    console.log(end.toISOString(), "EndDate2");
    // moment('2020-06-05').format('YYYY-MM-DDTHH:mm:ssZ')
    setOrderStartDate(start.toISOString());
    setOrderEndDate(end.toISOString());
  };

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  const toggleNavs = (e, index, val) => {
    e.preventDefault();
    setActiveNav(index);
    setRegion(val);
    // setChartExample1Data("data" + index);
  };


  useEffect(() => {
    fetchOrderReport();
  }, [orderStartDate, orderEndDate, region]);



  let fetchOrderReport = async () => {
    setIsLoadingOrderReport(true);
    let res = await getApiDataService(
      `${ORDER_REPORT}?start_date=${orderStartDate}&end_date=${orderEndDate}&region=${region}`
    );
    setOrderReports(res.data);
    setIsLoadingOrderReport(false);
  };
  return (
    <>
      <DashboardHeader />
      {/* Page content */}
      <Container className="mt--7 akh-page-content" fluid>
        <Row>
          <Col xl="12" className="mt-0">
            <ItemReport></ItemReport>
          </Col>

          <Col className="mt-4" xl="12">
            <FinancialReport></FinancialReport>
          </Col>

          <Col className="mt-4" xl="12">
            <PaymentAccountReport></PaymentAccountReport>
          </Col>

          <Col className="mt-4" xl="12">
            <ExpenseReport></ExpenseReport>
          </Col>
          {/* <Col xl="12" className="mt-4">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Daily Orders Report</h3>
                  </div>
                  <div className="col">
                    <Nav className="justify-content-end" pills>
                      <NavItem>
                        <NavLink
                          className={classnames("py-2 px-3", {
                            active: activeNav === 1,
                          })}
                          href="#pablo"
                          onClick={(e) => toggleNavs(e, 1,'Myanmar')}
                        >
                          <span className="d-none d-md-block">Myanmar</span>
                          <span className="d-md-none">M</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames("py-2 px-3", {
                            active: activeNav === 2,
                          })}
                          data-toggle="tab"
                          href="#pablo"
                          onClick={(e) => toggleNavs(e, 2,'Thai')}
                        >
                          <span className="d-none d-md-block">Thailand</span>
                          <span className="d-md-none">T</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames("py-2 px-3", {
                            active: activeNav === 3,
                          })}
                          data-toggle="tab"
                          href="#pablo"
                          onClick={(e) => toggleNavs(e, 3,'Other')}
                        >
                          <span className="d-none d-md-block">Other</span>
                          <span className="d-md-none">0</span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>
                  <div>
                  <DateRangePicker
                      onCallback={handleOrderCallback}
                    >
                      <input
                        style={{ width: "200px" }}
                        className="mx-2 form-control"
                        placeholder="Select date range"
                        aria-label="Date range"
                      />
                    </DateRangePicker>
                  </div>
                </Row>
              </CardHeader>
              {
                 isLoadingOrderReport ? (
                  <TableLoading />
                 ) : (
                  <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th className="text-center" scope="col">
                        Game Name
                      </th>
                      <th className="text-center" scope="col">
                        Order Count
                      </th>
                      <th className="text-center" scope="col">
                        Order Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderReports.map((item, index) => (
                      <tr>
                        <th className="text-center" scope="row">
                          {item?.game_name}
                        </th>
                        <td className="text-center">
                          {item?.count.toLocaleString("en-US")}
                        </td>
                        <td className="text-center">
                          {item?.price.toLocaleString("en-US")}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr
                      style={{
                        borderTop: "2px solid #1a174d",
                      }}
                    >
                      <td className="text-right bg-gradient-default shadow text-white">
                        Total :
                      </td>
                      <td className="text-center">
                        {orderReports
                          .reduce((a, b) => a + b.count, 0)
                          .toLocaleString("en-US")}
                      </td>
                      <td className="text-center">
                        {orderReports
                          .reduce((a, b) => a + b.price, 0)
                          .toLocaleString("en-US")}
                      </td>
                    </tr>
                  </tfoot>
                </Table>
                 )
              }
         
            </Card>
          </Col> */}
        </Row>
        {/* <Row className="mt-4">
          <Col xl="12" className="mb-0">
            <Card className="shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-muted ls-1 mb-1">
                      Performance
                    </h6>
                    <h2 className="mb-0">Total orders</h2>
                  </div>
                  <div>
                    <DateRange
                      setStartDate={setStartDate}
                      setEndDate={setEndDate}
                    />
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="chart">
                  <Pie
                    data={chartExample2.data}
                    options={chartExample2.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col className="mt-4" xl="12">
            <Card className="bg-gradient-default shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-light ls-1 mb-1">
                      Overview
                    </h6>
                    <h2 className="text-white mb-0">New User Growth</h2>
                  </div>
                 
                  <div>
                    <DateRange
                      setStartDate={setStartDate}
                      setEndDate={setEndDate}
                    />
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="chart">
                  <Line
                    data={chartExample1[chartExample1Data]}
                    options={chartExample1.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row> */}
      </Container>
    </>
  );
};

export default Index;
